import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import "./VideoCarousel.scss";
import { selectIcon, SVG } from "../../UI/selector";

const VideoCarousel = ({ heading, showExploreAll, ...props }) => {
  const ref = useRef(null);
  const [enableCarouselIcons, updateEnableCarouselIcons] = useState(false);
  const [rightCarouselIconVisibility, updateRightCarouselIconVisibility] =
    useState(false);
  const [leftCarouselIconVisibility, updateLeftCarouselIconVisibility] =
    useState(false);

  const updateIconsVisibility = (hoverType) => {
    updateLeftCarouselIconVisibility(hoverType && ref.current.scrollLeft);
    updateRightCarouselIconVisibility(
      hoverType
        ? Math.round(ref.current.scrollWidth - ref.current.scrollLeft) >
          ref.current.offsetWidth
          ? true
          : false
        : false
    );
  };

  const hoverOnCarousel = (hoverType) => {
    updateEnableCarouselIcons(hoverType);
    updateIconsVisibility(hoverType);
  };

  const leftRightNavigate = (scrollOffset) => {
    updateIconsVisibility(1);
    ref.current.scrollLeft += scrollOffset;
  };

  const divScroll = () => {
    updateIconsVisibility(1);
  };

  return (
    <div className="RowCarouselParentContainer">
      <p className="CarouselTitle text-h1">
        {heading}
        {showExploreAll && (
          <span className="CarouselSubTitle">Explore All</span>
        )}
      </p>
      {leftCarouselIconVisibility ? (
        <div
          className="leftIconDiv"
          onClick={() => leftRightNavigate(-window.innerWidth)}
          onMouseEnter={() => hoverOnCarousel(1)}
          onMouseLeave={() => hoverOnCarousel(0)}
        >
          <SVG className="leftIcon" src={selectIcon("leftArrow")} />
        </div>
      ) : null}
      {rightCarouselIconVisibility ? (
        <div
          className="rightIconDiv"
          onClick={() => leftRightNavigate(window.innerWidth)}
          onMouseEnter={() => hoverOnCarousel(1)}
          onMouseLeave={() => hoverOnCarousel(0)}
        >
          <SVG className="rightIcon" src={selectIcon("carouselRightIcon")} />
        </div>
      ) : null}

      <div
        className="RowCarouselContainer"
        onScroll={() => divScroll()}
        ref={ref}
        onMouseEnter={() => hoverOnCarousel(1)}
        onMouseLeave={() => hoverOnCarousel(0)}
      >
        <div className="RowCarouselParent">
          <div className="RowCarousel">
            <div className="paddingDiv"></div>
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoCarousel;

VideoCarousel.propTypes = {
  heading: PropTypes.string.isRequired,
  showExploreAll: PropTypes.bool,
};

VideoCarousel.defaultProps = {
  heading: "",
  showExploreAll: false,
};
